// tslint:disable-next-line:no-empty
function noop() {}

export { noop };
